import React, { Fragment, useEffect, useState } from "react";
import TransitionOnLoad from "Components/TransitionOnLoad";
import Step1 from "./Steps/Step1";
import Step2 from "./Steps/Step2";
import Step3 from "./Steps/Step3";
import Step4 from "./Steps/Step4";
import { useNavigate } from "react-router";
import { useCommunityData, useGeneratePDF, useSaveWeekstaatSchools, useSchoolList, useWeeklyScheduleList } from "Api/Coordinator/Weekstaten";

const Default = () => {
    const [formDataState, setFormDataState] = useState({
        communityData: "",
        bShowProlonged: "N",
        selectLangeContract: true,
        selectDagdelen: true,
        startDate: "",
        endDate: "",
        rdApproved: null,
        selectCoordinator: false,
        selectSchool: true,
        selectSalarisAdmin: false,
        selectCoordinatorAttach: false,
        selectSchoolAttach: false,
        selectSalarisAdminAttach: false,

        informText: `Op www.clooser.nl staat de weekstaat van %SCHOOL% %ORGANISATIE% voor de periode van %FROM_DATE% t/m %TO_DATE% voor u klaar.\nWilt u inloggen op www.clooser.nl en de weekstaat van bovenstaande periode beoordelen.\nIndien u de weekstaat wenst af te keuren dient u dit online toe te lichten.\nDeze mail is een systeembericht, u kunt hier niet op antwoorden.`,
        informEmail: "",
        emailList: [],
        datePickerStyle: "weekstaten-datePicker form-control",

        schoolList: [],
        selectedIds: [],
        automatic: null,

        weekList: [],
        itemsp: [],
        items: [],
    });

    const [step, setStep] = useState("step1");
    const [communityId, setCommunityId] = useState(0);
    const [loading, setLoading] = useState(true);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [weekstaatId, setWeekstaatId] = useState(0);

   const [generatePdf, setGeneratePdf] = useState(false);

const { data: generatePdfResponse } = useGeneratePDF(generatePdf);

    let currentSchoolId;
    const navigate = useNavigate();

    const { data: communityResponse } = useCommunityData(communityId);
    const { trigger: saveWeekstaatTrigger } = useSaveWeekstaatSchools();

    const { trigger: weeklyScheduleTrigger } = useWeeklyScheduleList();

    const { data: schoolListResponse } = useSchoolList(communityId);

    const totalCount = schoolListResponse?.totalCount;
    useEffect(() => {
        if (schoolListResponse?.status) {
            setFormDataState((prev) => ({
                ...prev,
                schoolList: schoolListResponse.data,
                selectedIds: schoolListResponse.data.map(
                    (item) => item.iSchoolId
                ),
            }));
        }
    }, [schoolListResponse]);

    const communityData = communityResponse || {};


    const convertEmails = (emailArray) => {
        return emailArray.join(";");
    };

    const saveWeekstaatData = () => {
        setLoading(true);

        const convertedEmails = convertEmails(formDataState.informEmail);

        const dataToSend = {
            school: formDataState.selectedIds,
            iCommunityId: communityId,
            rdAutoSend: formDataState.automatic == 1 ? "Y" : "N",
            rdApproved: formDataState.rdApproved == 1 ? "Y" : "N",
            selectLangeContract: formDataState.selectLangeContract ? "on" : "off",
            selectDagdelen: formDataState.selectDagdelen ? "on" : "off",
            dBeginDate: formDataState.startDate,
            dEndDate: formDataState.endDate,
            selectCoordinator: formDataState.selectCoordinator ? "on" : "off",
            selectSchool: formDataState.selectSchool ? "on" : "off",
            selectSalarisAdmin: formDataState.selectSalarisAdmin ? "on" : "off",
            selectCoordinatorAtach: formDataState.selectCoordinatorAttach ? "on" : "off",
            selectSchoolAttach: formDataState.selectSchoolAttach ? "on" : "off",
            selectSalarisAdminAttach: formDataState.selectSalarisAdminAttach ? "on" : "off",
            informEmail: convertedEmails ? convertedEmails : "",
            informText: formDataState.informText,
            vMelderReminder: formDataState.vMelderReminder || "",
        };

        saveWeekstaatTrigger({
            method: "post",
            data: dataToSend,
        })
            .then((response) => {

                if (response.status === true) {
                    setWeekstaatId(response.weekstaatId);

                    if (formDataState.automatic == 1) {
                        sessionStorage.setItem("pdfDownloading", true);

                          setGeneratePdf(true);

                        navigate("/weekstaten/overzicht");
                    } else {
                        getWeeklyschedulelist(0, response.weekstaatId, "nextId");
                    }

                    setLoading(false);
                }
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            });
    };

    const getWeeklyschedulelist = (index, weekstaatId, type) => {
        currentSchoolId = formDataState.selectedIds[index];
        const convertedItemsp = convertEmails(formDataState.itemsp);
        const convertedItems = convertEmails(formDataState.items);

        setLoading(true);

        const dataToSend = {
            iSchoolId: currentSchoolId,
            weekstaatId: weekstaatId,
            selectLangeContract: formDataState.selectLangeContract ? "on" : "off",
            selectDagdelen: formDataState.selectDagdelen ? "on" : "off",
            dBeginDate: formDataState.startDate,
            dEndDate: formDataState.endDate,
            rdApproved: formDataState.rdApproved == 1 ? "Y" : "N",
            itemsp: type == "refresh" ? "" : convertedItemsp,
            items: type == "refresh" ? "" : convertedItems,
            vMelderReminder: formDataState.vMelderReminder || "",
        };

        weeklyScheduleTrigger({
            method: "post",
            data: dataToSend,
        })
            .then((response) => {
                if (response.status === true) {
                    setFormDataState({
                        ...formDataState,
                        weekList: response.data,
                        itemsp: [],
                        items: [],
                    });
                    setStep("step4");
                    setLoading(false);
                }
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
            });
    };

    return (
        <Fragment>
            <TransitionOnLoad>
                {step == "step1" ? (
                    <Step1
                        setStep={setStep}
                        formDataState={formDataState}
                        setFormDataState={setFormDataState}
                        communityId={communityId}
                        setCommunityId={setCommunityId}
                        communityData={communityData}
                    />
                ) : step == "step2" ? (
                    <Step2
                        setStep={setStep}
                        formDataState={formDataState}
                        setFormDataState={setFormDataState}
                        totalCount={totalCount}

                    />
                ) : step == "step3" ? (
                    <Step3
                        setStep={setStep}

                        formDataState={formDataState}

                        communityId={communityId}
                        saveWeekstaatData={saveWeekstaatData}
                    />
                ) : (
                    <Step4
                        setStep={setStep}
                        formDataState={formDataState}
                        setFormDataState={setFormDataState}
                        communityId={communityId}

                        currentIndex={currentIndex}
                        setCurrentIndex={setCurrentIndex}
                        getWeeklyschedulelist={getWeeklyschedulelist}
                        weekstaatId={weekstaatId}
                    />
                )}
            </TransitionOnLoad>
        </Fragment>
    );
};

export default Default;